import { render, staticRenderFns } from "./Jimun.vue?vue&type=template&id=0a9e08e4&scoped=true&"
import script from "./Jimun.vue?vue&type=script&lang=js&"
export * from "./Jimun.vue?vue&type=script&lang=js&"
import style0 from "./Jimun.vue?vue&type=style&index=0&id=0a9e08e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e08e4",
  null
  
)

export default component.exports